/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ShellIndexRouteImport } from './routes/_shell.index'
import { Route as ShellAdminRouteImport } from './routes/_shell.admin'
import { Route as ShellColdStartRouteImport } from './routes/_shell.cold-start'
import { Route as ShellContextRouteImport } from './routes/_shell.context'
import { Route as ShellFlagsRouteImport } from './routes/_shell.flags'
import { Route as ShellInputsRouteImport } from './routes/_shell.inputs'
import { Route as ShellOutcomesRouteImport } from './routes/_shell.outcomes'
import { Route as ShellOutputsRouteImport } from './routes/_shell.outputs'
import { Route as ShellPlanRouteImport } from './routes/_shell.plan'
import { Route as ShellRunsRouteImport } from './routes/_shell.runs'
import { Route as ShellServicenowDocsRouteImport } from './routes/_shell.servicenow-docs'
import { Route as ShellSettingsRouteImport } from './routes/_shell.settings'
import { Route as ShellTeamRouteImport } from './routes/_shell.team'
import { Route as ShellWorkRouteImport } from './routes/_shell.work'
import { Route as ShellAdminDemosRouteImport } from './routes/_shell.admin_.demos'

const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellIndexRoute = ShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAdminRoute = ShellAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ShellRoute,
} as any)
const ShellColdStartRoute = ShellColdStartRouteImport.update({
  id: '/cold-start',
  path: '/cold-start',
  getParentRoute: () => ShellRoute,
} as any)
const ShellContextRoute = ShellContextRouteImport.update({
  id: '/context',
  path: '/context',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFlagsRoute = ShellFlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => ShellRoute,
} as any)
const ShellInputsRoute = ShellInputsRouteImport.update({
  id: '/inputs',
  path: '/inputs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOutcomesRoute = ShellOutcomesRouteImport.update({
  id: '/outcomes',
  path: '/outcomes',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOutputsRoute = ShellOutputsRouteImport.update({
  id: '/outputs',
  path: '/outputs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPlanRoute = ShellPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRunsRoute = ShellRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellServicenowDocsRoute = ShellServicenowDocsRouteImport.update({
  id: '/servicenow-docs',
  path: '/servicenow-docs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSettingsRoute = ShellSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTeamRoute = ShellTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWorkRoute = ShellWorkRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAdminDemosRoute = ShellAdminDemosRouteImport.update({
  id: '/admin_/demos',
  path: '/admin/demos',
  getParentRoute: () => ShellRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ShellIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof ShellAdminRoute
  '/cold-start': typeof ShellColdStartRoute
  '/context': typeof ShellContextRoute
  '/flags': typeof ShellFlagsRoute
  '/inputs': typeof ShellInputsRoute
  '/outcomes': typeof ShellOutcomesRoute
  '/outputs': typeof ShellOutputsRoute
  '/plan': typeof ShellPlanRoute
  '/runs': typeof ShellRunsRoute
  '/servicenow-docs': typeof ShellServicenowDocsRoute
  '/settings': typeof ShellSettingsRoute
  '/team': typeof ShellTeamRoute
  '/work': typeof ShellWorkRoute
  '/admin/demos': typeof ShellAdminDemosRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/admin': typeof ShellAdminRoute
  '/cold-start': typeof ShellColdStartRoute
  '/context': typeof ShellContextRoute
  '/flags': typeof ShellFlagsRoute
  '/inputs': typeof ShellInputsRoute
  '/outcomes': typeof ShellOutcomesRoute
  '/outputs': typeof ShellOutputsRoute
  '/plan': typeof ShellPlanRoute
  '/runs': typeof ShellRunsRoute
  '/servicenow-docs': typeof ShellServicenowDocsRoute
  '/settings': typeof ShellSettingsRoute
  '/team': typeof ShellTeamRoute
  '/work': typeof ShellWorkRoute
  '/': typeof ShellIndexRoute
  '/admin/demos': typeof ShellAdminDemosRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_shell': typeof ShellRouteWithChildren
  '/login': typeof LoginRoute
  '/_shell/admin': typeof ShellAdminRoute
  '/_shell/cold-start': typeof ShellColdStartRoute
  '/_shell/context': typeof ShellContextRoute
  '/_shell/flags': typeof ShellFlagsRoute
  '/_shell/inputs': typeof ShellInputsRoute
  '/_shell/outcomes': typeof ShellOutcomesRoute
  '/_shell/outputs': typeof ShellOutputsRoute
  '/_shell/plan': typeof ShellPlanRoute
  '/_shell/runs': typeof ShellRunsRoute
  '/_shell/servicenow-docs': typeof ShellServicenowDocsRoute
  '/_shell/settings': typeof ShellSettingsRoute
  '/_shell/team': typeof ShellTeamRoute
  '/_shell/work': typeof ShellWorkRoute
  '/_shell/': typeof ShellIndexRoute
  '/_shell/admin_/demos': typeof ShellAdminDemosRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/cold-start'
    | '/context'
    | '/flags'
    | '/inputs'
    | '/outcomes'
    | '/outputs'
    | '/plan'
    | '/runs'
    | '/servicenow-docs'
    | '/settings'
    | '/team'
    | '/work'
    | '/admin/demos'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/admin'
    | '/cold-start'
    | '/context'
    | '/flags'
    | '/inputs'
    | '/outcomes'
    | '/outputs'
    | '/plan'
    | '/runs'
    | '/servicenow-docs'
    | '/settings'
    | '/team'
    | '/work'
    | '/'
    | '/admin/demos'
  id:
    | '__root__'
    | '/_shell'
    | '/login'
    | '/_shell/admin'
    | '/_shell/cold-start'
    | '/_shell/context'
    | '/_shell/flags'
    | '/_shell/inputs'
    | '/_shell/outcomes'
    | '/_shell/outputs'
    | '/_shell/plan'
    | '/_shell/runs'
    | '/_shell/servicenow-docs'
    | '/_shell/settings'
    | '/_shell/team'
    | '/_shell/work'
    | '/_shell/'
    | '/_shell/admin_/demos'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ShellRoute: typeof ShellRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/': {
      id: '/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShellIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/admin': {
      id: '/_shell/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof ShellAdminRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/cold-start': {
      id: '/_shell/cold-start'
      path: '/cold-start'
      fullPath: '/cold-start'
      preLoaderRoute: typeof ShellColdStartRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/context': {
      id: '/_shell/context'
      path: '/context'
      fullPath: '/context'
      preLoaderRoute: typeof ShellContextRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/flags': {
      id: '/_shell/flags'
      path: '/flags'
      fullPath: '/flags'
      preLoaderRoute: typeof ShellFlagsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/inputs': {
      id: '/_shell/inputs'
      path: '/inputs'
      fullPath: '/inputs'
      preLoaderRoute: typeof ShellInputsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/outcomes': {
      id: '/_shell/outcomes'
      path: '/outcomes'
      fullPath: '/outcomes'
      preLoaderRoute: typeof ShellOutcomesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/outputs': {
      id: '/_shell/outputs'
      path: '/outputs'
      fullPath: '/outputs'
      preLoaderRoute: typeof ShellOutputsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/plan': {
      id: '/_shell/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof ShellPlanRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/runs': {
      id: '/_shell/runs'
      path: '/runs'
      fullPath: '/runs'
      preLoaderRoute: typeof ShellRunsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/servicenow-docs': {
      id: '/_shell/servicenow-docs'
      path: '/servicenow-docs'
      fullPath: '/servicenow-docs'
      preLoaderRoute: typeof ShellServicenowDocsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/settings': {
      id: '/_shell/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ShellSettingsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/team': {
      id: '/_shell/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof ShellTeamRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/work': {
      id: '/_shell/work'
      path: '/work'
      fullPath: '/work'
      preLoaderRoute: typeof ShellWorkRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/admin_/demos': {
      id: '/_shell/admin_/demos'
      path: '/admin/demos'
      fullPath: '/admin/demos'
      preLoaderRoute: typeof ShellAdminDemosRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellAdminRoute: typeof ShellAdminRoute
  ShellColdStartRoute: typeof ShellColdStartRoute
  ShellContextRoute: typeof ShellContextRoute
  ShellFlagsRoute: typeof ShellFlagsRoute
  ShellInputsRoute: typeof ShellInputsRoute
  ShellOutcomesRoute: typeof ShellOutcomesRoute
  ShellOutputsRoute: typeof ShellOutputsRoute
  ShellPlanRoute: typeof ShellPlanRoute
  ShellRunsRoute: typeof ShellRunsRoute
  ShellServicenowDocsRoute: typeof ShellServicenowDocsRoute
  ShellSettingsRoute: typeof ShellSettingsRoute
  ShellTeamRoute: typeof ShellTeamRoute
  ShellWorkRoute: typeof ShellWorkRoute
  ShellIndexRoute: typeof ShellIndexRoute
  ShellAdminDemosRoute: typeof ShellAdminDemosRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellAdminRoute: ShellAdminRoute,
  ShellColdStartRoute: ShellColdStartRoute,
  ShellContextRoute: ShellContextRoute,
  ShellFlagsRoute: ShellFlagsRoute,
  ShellInputsRoute: ShellInputsRoute,
  ShellOutcomesRoute: ShellOutcomesRoute,
  ShellOutputsRoute: ShellOutputsRoute,
  ShellPlanRoute: ShellPlanRoute,
  ShellRunsRoute: ShellRunsRoute,
  ShellServicenowDocsRoute: ShellServicenowDocsRoute,
  ShellSettingsRoute: ShellSettingsRoute,
  ShellTeamRoute: ShellTeamRoute,
  ShellWorkRoute: ShellWorkRoute,
  ShellIndexRoute: ShellIndexRoute,
  ShellAdminDemosRoute: ShellAdminDemosRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ShellRoute: ShellRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
